// extracted by mini-css-extract-plugin
export default {"container":"Legal_container__L6fJk","content":"Legal_content__36R7B","header":"Legal_header__5YrCK","section":"Legal_section__hZ1zL","contactSection":"Legal_contactSection__uHgBj"};